module.exports = __webpack_public_path__ + "img/full5-min.e807a7f2.png";